import React from 'react';
import { Icon } from '@dexma/ui-components';
import { StyledTabSideMenuConfiguration } from 'adapter/in/dashboards/pages/EditDashboard/WidgetMenu/Panel/Configuration/Tabs/Common/style';

type TabSideMenuConfigurationProps = {
    withError: boolean;
    title: string;
};

const TabSideMenuConfiguration = ({ withError, title }: TabSideMenuConfigurationProps): JSX.Element => (
    <StyledTabSideMenuConfiguration>
        {title}
        {withError && <Icon color='red' data-testid='icon-data-error' name='error' size={20} />}
    </StyledTabSideMenuConfiguration>
);

export default TabSideMenuConfiguration;
